import GithubCard from './GithubCard'

export default GithubCard
